module.exports = __webpack_public_path__ + "media/widget/Immunization-c2269151.png";